import React, { useState } from 'react';
import Layout from '../components/layout/Layout';
import ScheduleHeaderSection from '../components/schedule-header-section/ScheduleHeaderSection';
import ScheduleTable from '../components/schedule-table/ScheduleTable';
import { MarginContainer, NavLink } from '../lib/shared';
import {
  SchedulePageContainer,
  ScheduleInterventionsLogo,
  ToggleButtonContainer,
  InPersonToggleButton,
  OnlineToggleButton,
  ScheduleTableContainer,
} from '../page-styles/schedule.style';
import { icons } from '../style/icons';
import Head from '../components/head/Head';
import { useStaticQuery, graphql } from 'gatsby';

const SchedulePage = () => {
  const [isInPerson, setIsInPerson] = useState('true');
  const pageQuery = useStaticQuery(graphql`
    query ScheduleQuery {
      prismicSchedulePage {
        data {
          schedule_header {
            text
          }
          in_person_header {
            text
          }
          online_header {
            text
          }
          in_person_schedule {
            document {
              ... on PrismicSchedule {
                id
                data {
                  body {
                    ... on PrismicScheduleDataBodyColoredRow {
                      id
                      slice_type
                      primary {
                        schedule_item_description {
                          text
                        }
                        schedule_item_name {
                          text
                        }
                        time {
                          text
                        }
                      }
                    }
                    ... on PrismicScheduleDataBodyRow {
                      id
                      slice_type
                      primary {
                        schedule_item_description {
                          richText
                        }
                        schedule_item_name {
                          text
                        }
                        time {
                          text
                        }
                        tag {
                          text
                        }
                        speaker_details {
                          document {
                            ... on PrismicSpeakerInfos {
                              id
                              data {
                                speaker_details {
                                  speaker_name {
                                    text
                                  }
                                  speaker_position {
                                    text
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          online_schedule {
            document {
              ... on PrismicSchedule {
                id
                data {
                  body {
                    ... on PrismicScheduleDataBodyColoredRow {
                      id
                      primary {
                        schedule_item_name {
                          text
                        }
                        schedule_item_description {
                          text
                        }
                        time {
                          text
                        }
                      }
                      slice_type
                    }
                    ... on PrismicScheduleDataBodyRow {
                      id
                      primary {
                        schedule_item_description {
                          richText
                        }
                        schedule_item_name {
                          text
                        }
                        time {
                          text
                        }
                        tag {
                          text
                        }
                        speaker_details {
                          document {
                            ... on PrismicSpeakerInfos {
                              id
                              data {
                                speaker_details {
                                  speaker_name {
                                    text
                                  }
                                  speaker_position {
                                    text
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                      slice_type
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const {
    prismicSchedulePage: {
      data: {
        schedule_header: scheduleHeader,
        in_person_header: inPersonHeader,
        online_header: onlineHeader,
        in_person_schedule: inPersonSchedule,
        online_schedule: onlineSchedule,
      },
    },
  } = pageQuery;

  return (
    <Layout redLine={false}>
      <Head title="Schedule" />
      <SchedulePageContainer isInPerson={isInPerson}>
        <MarginContainer>
          <NavLink href={'/'}>
            <ScheduleInterventionsLogo
              src={
                isInPerson
                  ? icons.INTERVENTIONS_LOGO.image
                  : icons.INTERVENTIONS_WHITE_LOGO.image
              }
              alt={
                isInPerson
                  ? icons.INTERVENTIONS_LOGO.altText
                  : icons.INTERVENTIONS_WHITE_LOGO.altText
              }
            />
          </NavLink>
        </MarginContainer>
        <ScheduleHeaderSection
          title1={scheduleHeader.text.split(' ')[0]}
          title2={scheduleHeader.text.split(' ')[1]}
          isInPerson={isInPerson}
        />
        <MarginContainer>
          <ToggleButtonContainer>
            <InPersonToggleButton
              onClick={() => setIsInPerson(true)}
              isInPerson={isInPerson}
            >
              {inPersonHeader.text}
            </InPersonToggleButton>
            <OnlineToggleButton
              onClick={() => setIsInPerson(false)}
              isInPerson={isInPerson}
            >
              {onlineHeader.text}
            </OnlineToggleButton>
          </ToggleButtonContainer>
        </MarginContainer>
      </SchedulePageContainer>
      <ScheduleTableContainer isInPerson={isInPerson}>
        <ScheduleTable
          isInPerson={isInPerson}
          schedule={isInPerson ? inPersonSchedule : onlineSchedule}
        />
      </ScheduleTableContainer>
    </Layout>
  );
};

export default SchedulePage;
